import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 檔案下載
  // {
  //   path: '/file',
  //   name: 'file',
  //   component: () => lazyLoadView(import('@views/Service/File')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {
  //         const { brand, fileCategory, query, month, page = 1 } = routeTo.query
  //         const params = {
  //           contentType: 'file',
  //           search: query || undefined,
  //           brand_alias: brand || undefined,
  //           categoryAlias: fileCategory || undefined,
  //           search_date: month || undefined,
  //           limit: 10,
  //           orderBy: 'publish_up',
  //           page,
  //         }

  //         const [{ items, pagination }, BrandOptions, fileOptions] = await Promise.all([
  //           store.dispatch('global/searchFile', params),
  //           store.dispatch('option/fetchOptionList', {
  //             types: ['brand'],
  //             useCached: true
  //           }),
  //           store.dispatch('option/fetchOptionList', {
  //             types: ['download_file_category'],
  //             useCached: true
  //           })
  //         ])
  //         routeTo.params.list = items
  //         routeTo.params.pagination = pagination

  //         next()
  //       } catch(error) {
  //         routeError(error, routeTo, next({ name: '404' }));
  //       }
  //     }
  //   },
  //   props: (route) => ({
  //     list: route.params.list,
  //     pagination: route.params.pagination,
  //   })
  // },
  // 
  // {
  //   path: '/faq',
  //   name: 'faq',
  //   component: () => lazyLoadView(import('@views/Service/Faq')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {

  //         next()
  //       } catch (error) {
  //         routeError(error, routeTo, next({ name: '404' }));
  //       }
  //     }
  //   },
  // },

  // 常見問答
  // {
  //   path: '/faq',
  //   name: 'faq',
  //   component: () => lazyLoadView(import('@views/Service/Faq')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {

  //         routeTo.params.name = 'focusFirst'

  //         next()
  //       } catch(error) {
  //         routeError(error, routeTo, next({ name: '404' }));
  //       }
  //     }
  //   },
  // },
  // 代理品牌 分類頁
  // {
  //   path: '/faq/category/:categoryAlias',
  //   name: 'faq-category',
  //   component: () => lazyLoadView(import('@views/Service/Faq')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {

  //         // routeTo.params.breadcrumbTitle = 'IT基礎架構';

  //         next()
  //       } catch(error) {
  //         routeError(error, routeTo, next({ name: '404' }));
  //       }
  //     }
  //   },
  // },


  // 訂閱電子報
  {
    path: '/subscription',
    name: 'subscription',
    component: () => lazyLoadView(import('@views/Service/Subscription')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '電子報訂閱',
    },
  },
]
